import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportcab() {



  const cardData =
  {
    keyword: 'Pune Airport Cab ',
    heading: 'Sai Trupti Cabs: Pune Airport Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune Airport cab services, designed to make your airport transfers smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is handled by a professional, background-verified chauffeur who ensures timely pickup and drop-off at Pune Airport, courteous service, and safe, smooth driving. With transparent fares, flexible booking options, and 24×7 customer support, Sai Trupti Cabs makes your Pune Airport travel convenient, affordable, and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



 "services": [
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Reliable cab service from Pune to Mumbai Airport covering approximately 150–170 km. Offers AC and non-AC vehicles, professional drivers, flexible pickup points, luggage assistance, and real-time tracking. Ideal for business travelers, tourists, and early morning or late-night airport transfers with safe and timely drop."
    },
    {
      "name": "Pune to Shirdi Cab One Way",
      "description": "One-way cab service from Pune to Shirdi for a hassle-free pilgrimage. Includes AC/non-AC cars, experienced drivers familiar with highway routes, luggage support, flexible pickup timings, and transparent pricing. Perfect for solo travelers, families, and small groups seeking a direct journey."
    },
    {
      "name": "Pune to Mumbai Airport Cab Fare",
      "description": "Transparent and affordable cab fare from Pune to Mumbai Airport. Pricing depends on vehicle type (Sedan, SUV, or Innova), distance, and travel time. Includes tolls, driver allowance, and no hidden charges, ensuring a stress-free airport transfer experience."
    },
    {
      "name": "Pune Airport to Mumbai Airport",
      "description": "Seamless airport-to-airport cab service from Pune Airport to Mumbai Airport. Perfect for connecting flights, corporate travelers, or frequent flyers. Offers comfortable AC vehicles, punctual drivers, real-time tracking, and luggage handling."
    },
    {
      "name": "Pune Mumbai Airport Drop",
      "description": "Efficient airport drop service from Pune to Mumbai Airport with door-to-door pickup. Features AC/non-AC options, professional drivers, flexible scheduling, and assistance with luggage. Ideal for stress-free travel to catch flights on time."
    },
    {
      "name": "Pune Airport to Shirdi Taxi",
      "description": "Direct taxi service from Pune Airport to Shirdi offering AC/non-AC vehicles, experienced drivers, and smooth highway travel. Includes luggage assistance, flexible pickup, real-time tracking, and competitive fares suitable for pilgrims and tourists."
    },
    {
      "name": "Airport Taxi Pune",
      "description": "Reliable airport taxi service in Pune providing pickups and drop-offs at Pune Airport. Features professional drivers, clean vehicles, AC comfort, and timely service for both local and outstation travelers."
    },
    {
      "name": "Pune Airport Taxi",
      "description": "Dedicated Pune Airport taxi service with flexible pickup times, AC and non-AC options, luggage assistance, and prompt transfers to nearby cities or railway stations. Perfect for business or leisure travelers."
    },
    {
      "name": "Outstation Car Rental Pune",
      "description": "Outstation car rental service from Pune offering chauffeur-driven vehicles for long-distance travel. Includes Sedans, SUVs, and Innova options with AC comfort, experienced drivers, and safe highway travel to destinations like Shirdi, Mahabaleshwar, Lonavala, and Nashik."
    },
    {
      "name": "Airport Cabs Pune",
      "description": "Pune airport cab service offering reliable pickup and drop, real-time booking, professional drivers, and comfortable AC vehicles. Ideal for airport transfers and outstation travel from Pune."
    },
    {
      "name": "Pune Airport to Shirdi Cab Price",
      "description": "Competitive cab pricing from Pune Airport to Shirdi with transparent fares based on vehicle type and travel distance. Includes tolls, driver allowance, and luggage support, ensuring no hidden costs for pilgrims."
    },
    {
      "name": "Airport Cab Service Pune",
      "description": "Comprehensive cab service in Pune for airport pickups and drops. Offers AC and non-AC cars, professional drivers, on-time service, flexible scheduling, and support for luggage and road assistance."
    },
    {
      "name": "Airport Taxi Service in Pune",
      "description": "Trusted taxi service in Pune specializing in airport transfers. Features comfortable vehicles, courteous drivers, real-time tracking, and efficient routes to major destinations like Mumbai, Shirdi, Lonavala, and Mahabaleshwar."
    },
    {
      "name": "Airport Pickup and Drop Pune",
      "description": "Door-to-door airport pickup and drop service in Pune with professional chauffeurs, AC vehicles, real-time tracking, and flexible schedules. Ideal for domestic and international travelers."
    },
    {
      "name": "Airport Transfer Pune",
      "description": "Reliable airport transfer service in Pune offering comfortable vehicles, experienced drivers, and punctual service. Covers nearby cities and pilgrimage destinations with hassle-free travel."
    },
    {
      "name": "Cab from Pune Airport to Shirdi",
      "description": "Direct cab from Pune Airport to Shirdi providing smooth travel for pilgrims and tourists. Includes AC/non-AC options, experienced drivers, luggage support, flexible pickup points, and affordable fares."
    },
    {
      "name": "Pune Airport Drop",
      "description": "Efficient cab service for dropping passengers from Pune city to Pune Airport. Offers on-time pickup, AC comfort, professional drivers, luggage assistance, and transparent fares."
    },
    {
      "name": "Pune Airport Cab Booking",
      "description": "Instant online cab booking service for Pune Airport pickups and drops. Features multiple vehicle options, secure payment, real-time confirmation, and driver support for smooth travel."
    },
    {
      "name": "Pune Airport Drop Cab Service",
      "description": "Dedicated cab service for Pune airport drop with professional drivers, AC/non-AC vehicles, real-time tracking, luggage support, and flexible schedules ensuring timely airport arrival."
    },
    {
      "name": "Pune Airport Drop Charges",
      "description": "Transparent pricing for Pune airport drop services based on vehicle type, distance, and travel time. Includes tolls and driver allowances, ensuring a hassle-free and economical transfer."
    },
    {
      "name": "Pune Airport to Mahabaleshwar Cab",
      "description": "Outstation cab service from Pune Airport to Mahabaleshwar offering comfortable AC cars, scenic hill drive, professional drivers, luggage assistance, and flexible scheduling for tourists and weekend travelers."
    },
    {
      "name": "Pune Airport to Lonavala Cab",
      "description": "Cab service from Pune Airport to Lonavala ideal for leisure trips and weekend getaways. Features AC/non-AC vehicles, courteous drivers, scenic drive experience, and transparent fares."
    },
    {
      "name": "Pune Airport to Nashik Cab",
      "description": "Direct cab service from Pune Airport to Nashik for business, tourism, and pilgrimage trips. Offers AC comfort, experienced drivers, luggage support, and transparent pricing for smooth long-distance travel."
    },
    {
      "name": "Pune Airport to Bhimashankar Jyotirlinga Cab",
      "description": "Pilgrim-friendly cab service from Pune Airport to Bhimashankar Jyotirlinga. Includes AC vehicles, professional drivers familiar with forest and ghat routes, luggage assistance, and comfortable travel for devotees."
    },
    {
      "name": "Pune Airport to Kolhapur Cab",
      "description": "Outstation cab service from Pune Airport to Kolhapur offering AC/non-AC cars, experienced drivers, luggage support, and flexible schedules for tourists, business travelers, and families."
    },
    {
      "name": "Pune Airport to Ashtavinayak Darshan Cab",
      "description": "Specialized cab service from Pune Airport to Ashtavinayak temples for devotees. Offers comfortable vehicles, AC travel, experienced drivers, flexible itineraries, and transparent fare packages."
    },
    {
      "name": "Pune Airport to Sambhajinagar Cab",
      "description": "Direct cab service from Pune Airport to Sambhajinagar (Aurangabad) with AC/non-AC vehicles, professional chauffeurs, luggage support, and timely travel for business or pilgrimage."
    },
    {
      "name": "Pune Airport to Sangli Cab",
      "description": "Outstation cab service from Pune Airport to Sangli featuring AC/non-AC vehicles, reliable drivers, luggage support, flexible pickup/drop options, and scenic travel."
    },
    {
      "name": "Pune Airport to Panchgani Cab",
      "description": "Weekend getaway cab service from Pune Airport to Panchgani. Comfortable AC cars, scenic route through hills, flexible schedules, and experienced drivers make it perfect for family trips."
    },
    {
      "name": "Pune Airport to Solapur Cab",
      "description": "Cab service from Pune Airport to Solapur providing safe, timely, and comfortable travel with AC/non-AC options, experienced drivers, and luggage support."
    },
    {
      "name": "Pune Airport to Ahmednagar Cab",
      "description": "Direct cab service from Pune Airport to Ahmednagar with AC/non-AC vehicles, professional drivers, luggage assistance, and reliable long-distance travel for pilgrims and business travelers."
    },
    {
      "name": "Pune Airport to Jyotirlinga Darshan Package",
      "description": "Pilgrim package cab from Pune Airport covering multiple Jyotirlinga temples including Bhimashankar and others. Features AC vehicles, experienced drivers, planned itineraries, luggage support, and comfortable travel for devotees."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Airport Cab", "Pune to Shirdi Cab One Way"],
    ["Pune to Mumbai Airport Cab Fare", "Pune Airport to Mumbai Airport"],
    ["Pune Mumbai Airport Drop", "Pune Airport to Shirdi Taxi"],
    ["Airport Taxi Pune", "Pune Airport Taxi"],
    ["Outstation Car Rental Pune", "Airport Cabs Pune"],
    ["Pune Airport to Shirdi Cab Price", "Airport Cab Service Pune"],
    ["Airport Taxi Service in Pune", "Airport Pickup and Drop Pune"],
    ["Airport Transfer Pune", "Cab from Pune Airport to Shirdi"],
    ["Pune Airport Drop", "Pune Airport Cab Booking"],
    ["Pune Airport Drop Cab Service", "Pune Airport Drop Charges"],
    ["Pune Airport to Mahabaleshwar Cab", "Pune Airport to Lonavala Cab"],
    ["Pune Airport to Nashik Cab", "Pune Airport to Bhimashankar Jyotirlinga Cab"],
    ["Pune Airport to Kolhapur Cab", "Pune Airport to Ashtavinayak Darshan Cab"],
    ["Pune Airport to Sambhajinagar Cab", "Pune Airport to Sangli Cab"],
    ["Pune Airport to Panchgani Cab", "Pune Airport to Solapur Cab"],
    ["Pune Airport to Ahmednagar Cab", "Pune Airport to Jyotirlinga Darshan Package"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Pune Airport Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services to and from Pune Airport — perfect for business travelers, families, and tourists."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our fares for Pune Airport pickups and drop-offs start from approximately ₹800–₹1,500 for sedans, with SUVs and premium cars available at affordable rates."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or premium cars to suit your group size, luggage requirements, and comfort preferences for Pune Airport transfers."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with Pune Airport routes, ensuring timely pickups and safe, smooth journeys."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups from anywhere in Pune and drop-offs at the airport terminal, hotels, or other locations in the city."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and equipped with essential amenities for a comfortable and hygienic airport transfer."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, flight tracking, or route planning for your Pune Airport cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune Airport cab easily through a call, WhatsApp, or our website — with instant confirmation and quick vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune Airport cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable cab services to and from Pune Airport for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a Pune Airport cab with Sai Trupti Cabs?',
    answer: 'You can book your Pune Airport cab easily through our website, mobile app, WhatsApp, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available for Pune Airport transfers?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, tempo travellers, and luxury cabs for Pune Airport transfers.',
  },
  {
    question: 'Are the drivers experienced for Pune Airport trips?',
    answer: 'Yes, all our drivers are professional, courteous, and familiar with Pune Airport routes to ensure timely and safe travel.',
  },
  {
    question: 'Can I hire a cab for early morning or late-night Pune Airport pickups?',
    answer: 'Yes, our Pune Airport cab service is available 24×7 to accommodate flights at any time of the day or night.',
  },
  {
    question: 'Is the Pune Airport cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune Airport pickups and drop-offs.',
  },
  {
    question: 'What are the Pune Airport cab fares?',
    answer: 'Our fares start from approximately ₹800 for sedans and ₹1,500–₹2,500 for SUVs and premium vehicles, depending on travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune Airport cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune Airport cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'Is customer support available during the Pune Airport cab ride?',
    answer: 'Yes, our 24×7 customer support team is available throughout your Pune Airport cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Deshmukh',
    feedback: 'Booked a Pune Airport cab with Sai Trupti Cabs. Punctual pickup and comfortable ride to the airport.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Excellent Pune Airport cab service. Clean vehicle and polite driver made the journey hassle-free.',
    rating: 5,
  },
];
















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Pune Airport Cab Service with Sai Trupti Cabs for a safe, comfortable, and affordable ride. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-airport-cab"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune Airport Cab Service | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Airport Cab Service with Sai Trupti Cabs for a safe, comfortable, and affordable ride. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune Airport Cab, Pune Airport Taxi, Pune Airport Car Hire, Pune Airport Innova Cab, Pune Airport Ertiga Cab, Pune Airport Sedan Cab, Pune Airport One Way Cab, Pune Airport Drop Cab, Pune Airport Luxury Cab, Pune Airport Outstation Cab, Affordable Pune Airport Cab, Pune Airport AC Cab, Pune Airport Online Booking, Pune Airport Corporate Cab, Pune Airport Cab Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairportcab;